import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function LetterMLogoIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3761 6L22.0001 9.134V19H19.5001V10.384L16.3761 8.496L13.2521 10.384V19H10.7521V10.384L7.61812 8.502L4.50012 10.384V19H2.00012V6.628H4.50012V7.874L7.62412 6L12.0081 8.564L16.3761 6Z",
    fill: "currentColor"
  }));
}